module.exports = __webpack_public_path__ + "static/img/23.df109be.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/img/events/23.jpeg
// module id = kpr1
// module chunks = 1